import {
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_LOADING,
  CHANGE_PASSWORD_SUCCESS,
  PASSWORD_RESET_CONFIRM_ERROR,
  PASSWORD_RESET_CONFIRM_LOADING,
  PASSWORD_RESET_CONFIRM_SUCCESS,
  PASSWORD_RESET_REQUEST_ERROR,
  PASSWORD_RESET_REQUEST_LOADING,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_STATE_RESET,
} from "../values/action_types";

const INITIAL_STATE = {
  loading: false,
  error: null,
  // password-reset request (forgot password) was accepted by the backend
  resetRequested: false,
  // password-reset confirm (new password set via email link) succeeded
  resetConfirmed: false,
  // logged-in change-password succeeded
  changed: false,
};

export default function (state = INITIAL_STATE, action) {
  const { type, error } = action;

  switch (type) {
    case PASSWORD_RESET_REQUEST_LOADING:
    case PASSWORD_RESET_CONFIRM_LOADING:
    case CHANGE_PASSWORD_LOADING:
      return { ...state, loading: true, error: null };

    case PASSWORD_RESET_REQUEST_SUCCESS:
      return { ...INITIAL_STATE, resetRequested: true };

    case PASSWORD_RESET_CONFIRM_SUCCESS:
      return { ...INITIAL_STATE, resetConfirmed: true };

    case CHANGE_PASSWORD_SUCCESS:
      return { ...INITIAL_STATE, changed: true };

    case PASSWORD_RESET_REQUEST_ERROR:
    case PASSWORD_RESET_CONFIRM_ERROR:
    case CHANGE_PASSWORD_ERROR:
      return { ...state, loading: false, error };

    case PASSWORD_STATE_RESET:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
}
